function artists() {

    if ( !! $('#the-artist').length ) {


        $('#artist-search-filter').on('submit', function(e) {
            e.preventDefault();
        })



        $.extend($.expr[":"], {
            "containsIN": function(elem, i, match, array) {
                return (elem.textContent || elem.innerText || "").toLowerCase().indexOf((match[3] || "").toLowerCase()) >= 0;
            }
        });

        var updateList = function() {

            var allRows = $('.afilter li');
            allRows.removeClass('hiddenRow');
            var clickedText = $('#the-artist').val();
            var theCounter = 0;

            allRows.each(function(){
                if( ! $(this).is(`:containsIN("${clickedText}")`))  {
                    $(this).addClass('hiddenRow');
                } else {

                    theCounter = theCounter +1;
                }
            });

            $('#fts strong').html(theCounter);

        }

        updateList();

        if( !! $("#active-artist").length)
        {
            var thenav = document.getElementById('active-artist');
            var topPos = thenav.offsetTop;
            topPos = topPos - 240;

            if (topPos > 2 && !!$(".artists-scoller").length) {
                document.getElementById('artistnav').scrollTop = topPos || 1;
            }
        }

        $('#the-artist').on('keyup', function(e) {
            updateList();
        });

        $('#the-artist').on('blur', function(e) {
            updateList();
        });

    }

    /*
    $('section#main').on('click', '.artist-nav li a', function(){
        log('test');
        $('.artist-nav li.active').removeClass('active');
        $(this).addClass('clicked');
    });
    $('.artists-list').cycle('destroy');
    $('.artists-list').cycle({
        fx: 'fade',
        random: 1,
        speed: 1000,
        delay: 0,
        timeout: 6000,
        prev:    '#prev',
        next:    '#next',
        pagerAnchorBuilder: pagerFactory
    });
    function pagerFactory(idx, slide) {
        var s = idx > 2 ? ' style="display:none"' : '';
        return '<li'+s+'><a href="#">'+(idx+1)+'</a></li>';
    };
    */
};
